<dw-picker
  [isRange]="false"
  [value]="dwValue"
  (valueChange)="onValueChange($event)"
  [open]="dwOpen"
  [disabled]="dwDisabled"
  [format]="dwFormat"
  [allowClear]="dwAllowClear"
  [autoFocus]="dwAutoFocus"
  [className]="dwClassName"
  [placeholder]="dwPlaceHolder"
  [size]="dwSize"
  [style]="dwStyle"
  (openChange)="onOpenChange($event)"
>
  <div *ngIf="realOpenState">
    <div class="ant-calendar-picker-container {{ dwDropdownClassName }} ant-calendar-picker-container-placement-bottomLeft" [ngStyle]="dwPopupStyle">
      <div class="ant-calendar ant-calendar-month ant-calendar-month-calendar" tabindex="0">
        <div class="ant-calendar-month-calendar-content">
          <div class="ant-calendar-month-header-wrap">
            <calendar-header
              [disabledMonth]="dwDisabledDate"
              [panelMode]="panelMode"
              (panelModeChange)="onPanelModeChange($event)"
              [value]="dwValue"
              (chooseYear)="onChooseValue('year', $event)"
              (chooseMonth)="onChooseValue('month', $event)"
              [locale]="dwLocale.lang"
              [enablePrev]="true"
              [enableNext]="true"
            ></calendar-header>
          </div>
          <calendar-footer *ngIf="extraFooter" [extraFooter]="extraFooter"></calendar-footer>
        </div>
      </div>
    </div>
  </div>
</dw-picker>